import { render, staticRenderFns } from "./examenes-form.vue?vue&type=template&id=16ce16e9&scoped=true"
import script from "./examenes-form.vue?vue&type=script&lang=js"
export * from "./examenes-form.vue?vue&type=script&lang=js"
import style0 from "./examenes-form.vue?vue&type=style&index=0&id=16ce16e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ce16e9",
  null
  
)

export default component.exports